import { graphql } from "@/graphql/codegen"

import "@/entityLock/graphql/entityLock.fragment"
import "./invoice.fragment"

graphql(`
  mutation CreateInvoice($input: CreateInvoiceInput!) {
    invoice {
      create(input: $input) {
        __typename
        ... on CreateInvoiceSuccess {
          invoice {
            invoiceId
            ...InvoiceBaseFields
          }
        }
        ... on CreateInvoiceFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation UpdateInvoice($input: UpdateInvoiceInput!) {
    invoice {
      update(input: $input) {
        __typename
        ... on UpdateInvoiceSuccess {
          invoice {
            invoiceId
            ...InvoiceBaseFields
          }
        }
        ... on UpdateInvoiceFailure {
          error {
            message
          }
        }
        ... on EntityLockFailure {
          error {
            message
            currentLock {
              ...EntityLockBaseFields
            }
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ConfirmInvoiceAs400ManualReconciliation($input: InvoiceAs400ManualReconciliationInput!) {
    invoice {
      confirmAs400ManualReconciliation(input: $input) {
        __typename
        ... on InvoiceAs400ManualReconciliationSuccess {
          invoice {
            invoiceId
            as400ReversalSyncStatus
            as400PaidSyncStatus
            as400VoidSyncStatus
          }
        }
        ... on InvoiceAs400ManualReconciliationFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
